

const data = {
  p1: {
    title: "数字员工直播平台",
    subtitle: "一键生成直播间，智启AI电商时代",
    link: "https://aibeingslivestream.xiaoice.com",
  },
  p2: {
    title: "以AI生产力赋能电商直播",
    subtitle: "开拓全球化增长",
    desc: [
      "基于直播平台已配置的商品列表，一键生成AI直播间",
      "60秒内自动完成视觉搭建，生成直播脚本及互动话术",
      "支持多语言跨平台部署，实现无人值守全天候直播",
      "以低成本高效能模式，助力企业突破技术壁垒与流量边界"
    ]
  },
  p3: {
    title: "产品优势",
    steps: [
      "一键搭建直播间",
      "全球化多语言交互",
      "智能响应问答",
      "支持多平台开播"
    ]
  }
};
export default data;